// extracted by mini-css-extract-plugin
export default {"skeleton-title":"settings-audit_skeleton-title__EpAiV","skeleton-icon":"settings-audit_skeleton-icon__rkN5z","skeleton-summary":"settings-audit_skeleton-summary__jswwM"};